import { useState, useEffect } from "react";
import { Route, Switch, Redirect, useLocation } from "react-router-dom";

// @mui material components
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import CircularProgress from "@mui/material/CircularProgress";

// Vision UI Dashboard React example components
import Sidenav from "examples/Sidenav";

// Vision UI Dashboard React themes
import theme from "assets/theme";

// Vision UI Dashboard React routes
import routes from "routes";

// Vision UI Dashboard React contexts
import { useVisionUIController, setMiniSidenav } from "context";
import { AuthProvider, useAuth } from "./context/AuthContext";

function AppContent() {
  const [controller, dispatch] = useVisionUIController();
  const { miniSidenav, sidenavColor, layout } = controller;
  const [onMouseEnter, setOnMouseEnter] = useState(false);
  const { pathname } = useLocation();
  const { isAuthenticated, loading } = useAuth();

  const handleOnMouseEnter = () => {
    if (miniSidenav && !onMouseEnter) {
      setMiniSidenav(dispatch, false);
      setOnMouseEnter(true);
    }
  };

  const handleOnMouseLeave = () => {
    if (onMouseEnter) {
      setMiniSidenav(dispatch, true);
      setOnMouseEnter(false);
    }
  };

  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  const isAuthRoute = pathname.startsWith("/authentication");

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh",
          backgroundColor: "#080B2A",
        }}
      >
        <CircularProgress sx={{ color: "#0075ff" }} />
      </div>
    );
  }

  // Filter visible routes for Sidenav
  const sidenavRoutes = routes.filter((r) => !r.hidden);

  const renderRoutes = (allRoutes) =>
    allRoutes.map((route) => {
      if (route.collapse) {
        return renderRoutes(route.collapse);
      }
      if (route.route) {
        return (
          <Route
            exact
            path={route.route}
            key={route.key}
            render={(props) => {
              if (route.route.startsWith("/authentication")) {
                if (isAuthenticated) {
                  return <Redirect to="/dashboard" />;
                }
                const Component = route.component;
                return <Component {...props} />;
              }

              if (!isAuthenticated) {
                return <Redirect to="/authentication/sign-in" />;
              }

              const Component = route.component;
              return <Component {...props} />;
            }}
          />
        );
      }
      return null;
    });

  const showSidenav = layout === "dashboard" && isAuthenticated && !isAuthRoute;

  return (
    <>
      {showSidenav && (
        <Sidenav
          color={sidenavColor}
          brand=""
          brandName="INTENT WEB"
          routes={sidenavRoutes}
          onMouseEnter={handleOnMouseEnter}
          onMouseLeave={handleOnMouseLeave}
        />
      )}
      <Switch>
        <Route exact path="/">
          <Redirect to={isAuthenticated ? "/dashboard" : "/authentication/sign-in"} />
        </Route>
        {renderRoutes(routes)}
        <Redirect to={isAuthenticated ? "/dashboard" : "/authentication/sign-in"} />
      </Switch>
    </>
  );
}

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </ThemeProvider>
  );
}
